
import LocatingPostChecklist from "./requiredForms/locatingPostChecklist";
import LocatingPreChecklist from "./requiredForms/locatingPreChecklist";
import PotholingPostChecklist from "./requiredForms/potholingPostChecklist";
import PotholingPreChecklist from "./requiredForms/potholingPreChecklist";
//-------------------------------------------------------------------------
import ElectricPotholeForm from "./optionalForms/electricPotholeForm";
import IncidentReport from "./optionalForms/incidentReport";
import EquipmentDamageReport from "./optionalForms/equipmentDamageReport";
import GPRForm from "./optionalForms/gprForm";
import LocatingForm from "./optionalForms/locatingForm";
import GasLeakSurvey from "./optionalForms/gasLeakSurvery";
import CCTVForm from "./optionalForms/cctvForm";
import GoodCatchForm from "./optionalForms/goodCatchForm";
import NearMissForm from "./optionalForms/nearMissForm";
import SacromentoVacuumFieldSurvey from "./optionalForms/sacromentoVacuumFieldSurvey";
import WeeklyMaintenanceZerkFittings from "./optionalForms/weeklyMaintenanceZerkFittings";
import ManholeForm from "./optionalForms/manholeForm";
import TestManholeForm from "./optionalForms/testManholeForm";
import TestPotholingForm from "./optionalForms/testPotholingForm";
import MultiSiteJSA from "./optionalForms/multiSiteJSA";
import WorkplaceViolenceIncidentReportForm from "./optionalForms/workplaceViolenceIncidentReportForm";
import InScopeWorkDiary from "./optionalForms/inScopeWorkDiaryForm";
//--------------------------------------------------------------------------------------------
export default function OptionalForms({...rest}){
    const curFormName = 
    rest.formRequired?
    rest.formName:
    rest.form.form;
    //--------------------------------------------------------------------------------------------
    return(
        <>
        {curFormName === "potholingPreChecklist"?<PotholingPreChecklist {...rest}/>:<></>}
        {curFormName === "potholingPostChecklist"?<PotholingPostChecklist {...rest}/>:<></>}
        {curFormName === "locatingPreChecklist"?<LocatingPreChecklist {...rest}/>:<></>}
        {curFormName === "locatingPostChecklist"?<LocatingPostChecklist {...rest}/>:<></>}
        {/*---------------------------------------------------------------------------*/}
        {curFormName === "Electric Pothole Form"?<ElectricPotholeForm {...rest}/>:<></>}
        {curFormName === "Incident Report"?<IncidentReport {...rest}/>:<></>}
        {curFormName === "Equipment Damage Report"?<EquipmentDamageReport {...rest}/>:<></>}
        {curFormName === "GPR Form"?<GPRForm {...rest}/>:<></>}
        {curFormName === "Locating Form"?<LocatingForm {...rest}/>:<></>}
        {curFormName === "Gas Leak Survey"?<GasLeakSurvey {...rest}/>:<></>}
        {curFormName === "CCTV Form"?<CCTVForm {...rest}/>:<></>}
        {curFormName === "Good Catch Form"?<GoodCatchForm {...rest}/>:<></>}
        {curFormName === "Near Miss Form"?<NearMissForm {...rest}/>:<></>}
        {curFormName === "Sacramento Vacuum Field Survey"?<SacromentoVacuumFieldSurvey {...rest}/>:<></>}
        {curFormName === "Weekly Maintenance Zerk Fittings"?<WeeklyMaintenanceZerkFittings {...rest}/>:<></>}
        {curFormName === "Multi Site JSA"?<MultiSiteJSA {...rest}/>:<></>}
        {curFormName === "Manhole Form"?<ManholeForm {...rest}/>:<></>}
        {curFormName === "Test Manhole Form"?<TestManholeForm {...rest}/>:<></>}
        {curFormName === "Test Potholing Form"?<TestPotholingForm {...rest}/>:<></>}
        {curFormName === "Workplace Violence Incident Report Form"?<WorkplaceViolenceIncidentReportForm {...rest}/>:<></>}
        {curFormName === "In Scope Work Diary"?<InScopeWorkDiary {...rest}/>:<></>}
        </>
    )    
}